import React, { Component } from 'react';
import range from 'lodash/range';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Modal from 'react-bootstrap/Modal';
import ReactToPrint from 'react-to-print';
import { ACCOUNT_TYPE } from 'containers/ProfileDetailsPage/profileUtils';
import LoadingIndicator from 'components/LoadingIndicator';
import TextButton from 'components/TextButton';
import { formatDate, formatMoney } from 'utils/formatting';
import IconClose from 'resources/icon-close-black.svg';
import withWinLossData from './withWinLossData';
import IconPrint from './assets/icon-print.svg';
import './WinLossStatement.css';

class Statement extends Component {
  calculatePropertyTotal(property) {
    let total = 0;
    property.propertyValue.forEach(monthValue => {
      total += monthValue.value;
    });

    return total;
  }

  formatWinLossValue(number) {
    if (number < 0) {
      return `(${formatMoney(Math.abs(number * 100))})`;
    }

    return formatMoney(number * 100);
  }

  renderNetWinLossMonthly(winLossData) {
    let monthlyNetWinLoss = new Array(12);
    monthlyNetWinLoss.fill(0);

    winLossData.properties.forEach(property => {
      property.propertyValue.forEach(({ month, value }, i) => {
        monthlyNetWinLoss[i] += value;
      });
    });

    return monthlyNetWinLoss.map((netValue, i) => (
      <span key={i}>{this.formatWinLossValue(netValue)}</span>
    ));
  }

  renderNetWinLossTotals(winLossData) {
    let netTotal = 0;
    let propertyTotals = winLossData.properties.map((property, i) => {
      let total = this.calculatePropertyTotal(property);
      netTotal += total;

      return <span key={i}>{this.formatWinLossValue(total)}</span>;
    });

    propertyTotals.push(
      <span key={winLossData.properties.length + 1}>
        {this.formatWinLossValue(netTotal)}
      </span>
    );

    return propertyTotals;
  }

  render() {
    const {
      firstName,
      lastName,
      accountNumber,
      year,
      handleSelectYear,
      yearsRange,
      data
    } = this.props;
    const { winLossHistory } = data;

    return (
      <div className="win-loss-statement">
        <StatementHeader year={year} />
        <div className="statement-info-container">
          <div className="full-name">
            <span className="field-header">Name:</span>
            <br />
            {`${firstName} ${lastName}`}
          </div>
          <div className="account-number">
            <span className="field-header">Acct:</span>
            <br />
            {accountNumber}
          </div>
          <div className="report-generated-timestamp">
            <span className="field-header">Report Generated:</span>
            <br />
            {formatDate(moment(), 'fullLocalTime')}
          </div>
          <div className="year-select-container">
            <span className="field-header">Year:</span>
            <span className="year-display">{year}</span>
            <FormControl
              className="year-select"
              as="select"
              onChange={handleSelectYear}
              value={year}
            >
              {yearsRange.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </FormControl>
          </div>
        </div>
        <div className="statement-result">
          <div className="statement-result-table">
            <div className="statement-result-header">
              <span>Month</span>
              <span>January</span>
              <span>February</span>
              <span>March</span>
              <span>April</span>
              <span>May</span>
              <span>June</span>
              <span>July</span>
              <span>August</span>
              <span>September</span>
              <span>October</span>
              <span>November</span>
              <span>December</span>
            </div>
            {winLossHistory.properties.map((property, i) => {
              let propertyName = property.name;
              if (propertyName === 'alabama') {
                propertyName += '*';
              }
              return (
                <div
                  className="statement-result-property"
                  style={
                    propertyName === 'iGaming PA'
                      ? {}
                      : { textTransform: 'capitalize' }
                  }
                  key={i}
                >
                  <span>{propertyName}</span>
                  {property.propertyValue.map((monthValue, j) => (
                    <span key={j}>
                      {this.formatWinLossValue(monthValue.value)}
                    </span>
                  ))}
                </div>
              );
            })}
            <div className="statement-result-property">
              <span>Net Win/(Loss)</span>
              {this.renderNetWinLossMonthly(winLossHistory)}
            </div>
          </div>
          <hr />
          <div className="statement-result-total">
            <span>{year} Total</span>
            {this.renderNetWinLossTotals(winLossHistory)}
          </div>
        </div>
      </div>
    );
  }
}

const StatementHeader = ({ year }) => {
  return (
    <div className="statement-header-container">
      <div className="statement-header">
        PCI Gaming dba Wind Creek Hospitality
        <br />
        Player&apos;s Estimated Win/Loss for {year}
      </div>
      <div className="statement-description">
        The casino is not responsible for the accuracy of this estimate. Ask
        your tax advisor if you have questions about deducting gaming losses on
        your tax return. The win or loss figure shown is a net amount, inclusive
        of any reportable slot jackpot winnings for the year.
        <br />
        *Alabama figures represent a total of Wind Creek Atmore, Wind Creek
        Montgomery, Wind Creek Wetumpka, and Wa She Shu.
      </div>
    </div>
  );
};

export const MiamiDisclaimer = ({ year }) => {
  return (
    <div className="win-loss-magic-city-disclaimer ">
      <StatementHeader year={year} />
      <div className="disclaimer">
        For Magic City Win/Loss statements, both historical and current, please
        speak with a representative on property at Magic City.
      </div>
    </div>
  );
};

class StatementContainer extends Component {
  render() {
    const { loading, error } = this.props.data;
    if (loading) {
      return <LoadingIndicator />;
    }

    if (error) {
      return (
        <div className="win-loss-error alert alert-danger">
          Failed to retrieve Win Loss Statement. If this continues, please
          contact support.
        </div>
      );
    }

    return (
      <React.Fragment>
        <Statement {...this.props} ref={el => (this.componentRef = el)} />
        <ReactToPrint
          trigger={() => (
            <Button
              className="print-statement-button"
              onClick={() => window.print()}
            >
              <img className="print-icon" src={IconPrint} alt="" />
              Print
            </Button>
          )}
          content={() => this.componentRef}
          bodyClass="print-win-loss-statement"
        />
      </React.Fragment>
    );
  }
}

const StatementContainerWithData = withWinLossData(StatementContainer);

class WinLossStatement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: moment().year()
    };

    this.handleSelectYear = this.handleSelectYear.bind(this);
  }

  handleSelectYear(event) {
    const value = event.target.value ?? event.target.getAttribute('value');
    this.setState({
      year: parseInt(value, 10) || moment().year()
    });
  }

  render() {
    const {
      handleClose,
      show,
      accountType,
      accountNumber,
      joinYear,
      firstName,
      lastName
    } = this.props;

    let yearsRange = range(joinYear, moment().year() + 1).reverse();

    let content = null;
    if (accountType === ACCOUNT_TYPE.PLS_ACCOUNT) {
      content = <MiamiDisclaimer year={this.state.year} />;
    } else {
      content = (
        <StatementContainerWithData
          accountType={accountType}
          firstName={firstName}
          lastName={lastName}
          accountNumber={accountNumber}
          year={this.state.year}
          handleSelectYear={this.handleSelectYear}
          yearsRange={yearsRange}
        />
      );
    }

    return (
      <Modal
        className="win-loss-statement-modal"
        onHide={handleClose}
        show={show}
      >
        <Modal.Body>
          <TextButton className="modal-close-button" onClick={handleClose}>
            <img src={IconClose} alt="Close" />
          </TextButton>
          {content}
        </Modal.Body>
      </Modal>
    );
  }
}

export default WinLossStatement;
